module.exports = __webpack_public_path__ + "static/media/landing.e4a1f097.jpg";